import native from "./native";
import SystemInfo from "./SystemInfo";

const isTouchDevice =
	native ||
	SystemInfo.OS === "ios" ||
	SystemInfo.OS === "android" ||
	SystemInfo.OS === "windows phone";
export default isTouchDevice;
